//store representing the current scope(s)
import { computed } from 'vue';
import { defineStore } from 'pinia'
import {type Tag, tagSchema } from '../types/types' //Scope is the same as Tag for now
import { useStoreSyncer } from '@/composables/Store-syncer';

//TODO this should just read, write, delete an entire scope, backend does the work
export const useScopeStore = defineStore('scopes', () => {
    const { fetchAll, update, remove, create, allItems, loading, error } = useStoreSyncer('/scopes', 'scopes'); 

    const allScopes = computed(()=>{
      return allItems.value.map((scope : Tag) =>{
        return scope['name'];
      });
    })

  /**
   * return a scope from its id
   * @returns
   */
  async function getById(id: String) {
    console.log(`scope store.getById(${id})....fetching from api/backend...`)
    try {
      const scope = allScopes.value.filter((scope : Tag) =>{
        return scope.id == id;
      })[0];

      return scope
    } catch (error) {
      console.error(error)
    }
    return { id: 'empty', name: 'nothing found' }
  }

  async function fetchAllScopes(){
    return await fetchAll();
  }

  /**
   * add a new scope
   */
  async function add(scope: Tag) {
    console.log('scope store adding new scope : ' + scope.name)
    return await create(scope, tagSchema, 'tag');
  }

  return { allScopes, fetchAllScopes, getById, add }
})
